<p-carousel [value]="getPicturesUrl()" [numVisible]="1" [circular]="false" [responsiveOptions]="responsiveOptions" *ngIf="getPicturesUrl().length > 0">
  <ng-template let-pictureUrl pTemplate="item">
    <div class="mb-3" style="height: 50%;">
      <img [src]="pictureUrl" style="border-radius: 7px; width: 100%; height: auto;" alt="Image" />
    </div>
  </ng-template>
</p-carousel>
<span style="border-radius: 7px; padding: 5px; font-weight: bold;" *ngIf="getPicturesUrl().length < 1">{{'MarketplacePage.WishList.ExportOfferModal.NoImageText' | translate}}</span>
